import { render, staticRenderFns } from "./rwkursus.vue?vue&type=template&id=3610457d"
import script from "./rwkursus.vue?vue&type=script&lang=js"
export * from "./rwkursus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports